import { render, staticRenderFns } from "./LiveCameraView.vue?vue&type=template&id=39bd6299&scoped=true"
import script from "./LiveCameraView.vue?vue&type=script&lang=js"
export * from "./LiveCameraView.vue?vue&type=script&lang=js"
import style0 from "./LiveCameraView.vue?vue&type=style&index=0&id=39bd6299&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd6299",
  null
  
)

export default component.exports